export default "__VITE_ASSET__CrPuFP46__"